import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { ExerciseSwitchPage } from './exercise-switch';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ExerciseSwitchPage],
    imports: [PagesModule, ComponentsModule],
    exports: [ExerciseSwitchPage]
})
export class ExerciseSwitchPageModule { }
